import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom' // Ensure this import is correct
import App from './App.tsx'
import './index.css'

// Import GrowSumo test utilities for debugging
import('./utils/growSumoTest');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
